export const tdlr = {
  agencyCode: '452',
  name: 'Texas Department of Licensing and Regulation',
  shortName: 'Licensing and Regulation',
  slug: 'tdlr',
};
